import { Box, Skeleton } from "@mui/material";
import { useEffect, useState } from "react";

export default function ProductSkeleton({ row, colSpan }) {
  const [skeletonList, setSkeletonList] = useState([]);

  useEffect(() => {}, []);

  return (
    <Box display={"flex"} flexDirection={"column"} gap={1} pt={1}>
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
      <Skeleton
        height={110}
        sx={{ mx: 1 }}
        variant="rounded"
        animation="wave"
      />
    </Box>
  );
}
